export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14708.4382c4cd.jpg";